import { MotorStatusMdl } from "./MotorStatusMdl";

export class QuoteReqMdl {
   public InsuredIDNo: string;       
   public InsuredName: string;   
   public MobileNo: string;      
   public Make: string="";      
   public  Model: string="";      
   public UseOfVechicle: string="";      
   public VechicleRegionCode: string="";      
   public insuredAge: string;      
   public VehcileAge: string;    
   public VehcileUsage: string="";       
   public AddressRegionCode: string="";      
   public SumInsured: number;      
   public DOB: string;     
   public DEDUCTIBLE_CODE: string="";       
   public AgencyRepair: string="";      
   public INSURED_DOB: string;   
   public  DRIVER1_DOB: string;       
   public  DRIVER3_DOB: string;
}

export class QuoteResMdl {
    
    public QuoteId: string;
    public TPLPremium: number;
    public CompPremium: number;
    public TPLPremiumExists:boolean
    public CompPremiumExists:boolean
    public st: MotorStatusMdl = new MotorStatusMdl();


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/QuoteReqMdl.ts